export default "__VITE_ASSET__43e89c83__"